import { render, staticRenderFns } from "./ThemenBearbeiten.vue?vue&type=template&id=0ec2c9a9&"
import script from "./ThemenBearbeiten.vue?vue&type=script&lang=js&"
export * from "./ThemenBearbeiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports